import {Component, Fragment, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {C, F, FR, E, CF, RE, R, Card} from "../_common/layout";
import {CompanyUser} from "../_api";
import {Form as FinalForm} from "react-final-form";
import {FormField, SubmitButtonRow} from "../_common/forms/components/components";
import {saveEmail, savePassword} from "../_rx/jobs/actions";
import {fetchUser} from "../_rx/_auth/actions";
import {toastService} from "../_services/toast-service";
import {Helmet} from "react-helmet";
import {USER_CHANGE_MAIL_TITLE_PAGE, USER_CHANGE_MAIL_TITLE} from "../constants";

type Props = {loggedUser: CompanyUser, fetchUser: Function, saveEmail: Function, history: any};


class View extends Component<Props,{}> {

    componentDidMount() {
        this.props.fetchUser()
    }

    async onSubmit(email: string, password: string){
        try {
            await this.props.saveEmail(email, password);
        } catch(e: any){
            const error = await e.json();
            if(e.status === 401) toastService.showToast({message: error.msg, type: 'danger'})
        };
        await this.props.fetchUser();
        this.props.history.push('/user');
    }

    render({ loggedUser, history }:Props) {

        if(!loggedUser) return null;

        return (
            <Fragment>
                <Helmet>
                    <title>{USER_CHANGE_MAIL_TITLE_PAGE}</title>
                </Helmet>
                <FinalForm
                onSubmit={({email, password}: any)=>{this.onSubmit(email, password)}} initialValues={loggedUser}
                render={({handleSubmit,  submitting}:any)=>
                        <form className='form' action="" onSubmit={handleSubmit}  noValidate>
                            <CF className='max-width'>
                                <Card smOnly={false} className='card m-top'>
                                    <h1>{t(USER_CHANGE_MAIL_TITLE)}</h1>
                                    <FR>
                                        <div className="col-100 sm-col-75">
                                            <FormField label={'Nuevo correo electrónico'} name="email" type="email" required />
                                        </div>
                                    </FR>
                                    <FR>
                                        <div className="col-100 sm-col-75 p-top">
                                            <FormField label={'Contraseña'} name="password" type="password" specificError={t('Contraseña operacion')} required />
                                            <p className="font-14">{t('Motivos seguridad')}</p>
                                        </div>
                                    </FR>
                                    <SubmitButtonRow disabled={submitting} onCancel={()=>history.push('/user')}/>
                                </Card>
                            </CF>
                        </form>
                }/>
            </Fragment>
        );
    }
}

const ConnectedView: any = connect(
    ({auth:{loggedUser}}:any)=>({loggedUser}), {fetchUser, saveEmail})(View as any);

export default ({history}:any) =>
    <AppPage
        name="user-email-change"
        title=""
        subtitle=""
        className="max-width">
        <ConnectedView history={history} />

    </AppPage>
;
